import React from "react";
import { toType } from '../../../utils/helpers';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import EditButton from "./EditButton";
import { Typography } from "src/latest/src/components";

const KeyValueContent = ({ value }) => {
    return <div className='d-flex'>
        {
            value.map((item) =>
                Object.values(item).map((v, j) => <React.Fragment>
                    <Typography variant={`size-${j % 2 === 0 ? '16' : '12'}`} weight={`${j % 2 === 0 ? 'regular' : 'bold'}`} color='color-2'
                        className={`therapist-profile__value-first ${j % 2 !== 0 ? 'therapist-profile__value-key' : ''}`}>
                        {v}
                    </Typography>
                </React.Fragment>)
            )
        }
    </div>;
};

const Content = ({ title, value, isRemoveTitle, icon, bgColor, color, classname, showPage, section, sectionClassName }) => {

    return (
        title !== "AVAILABILITY" ?
            <div  style={{ width: "100%" }}
                 className={` pb-24 ${sectionClassName}`}>
                {title !== 'EMAIL' && <EditButton section={section} showPage={showPage} />}
                {
                    !isRemoveTitle && <Typography variant='size-14' weight='bold' color='color-28'
                        className='therapist-profile__title'>
                        {title}
                    </Typography>
                }
                {
                    toType(value) === 'array' && toType(value[0]) === 'object' ? <KeyValueContent value={value} /> : <div className={icon ? 'therapist-profile__icon-container' : ''}>
                        {
                            icon && <span className='therapist-profile__icon' style={{ background: bgColor }}>
                                <FontAwesomeIcon icon={icon} color='#fff' />
                            </span>
                        }
                        <Typography variant='size-16' weight='regular' color={color !== undefined ? color : 'color-2'}
                            className={`${title === "Other Credentials & Certifications" ? 'therapist-profile__value-certificates' : `therapist-profile__value-first ${classname}`}  ${isRemoveTitle ? 'mt-0' : ''}`}>
                            {value}
                        </Typography>
                    </div>
                }
            </div> : ""
    );

};

export default Content;


